import {
    SET_BARCODE_REPORT_ASSET_IMAGES,
    SET_BARCODE_REPORT_COSTCENTER_DROPDOWN,
    SET_BARCODE_REPORT_EXCEL_DATA,
    SET_BARCODE_REPORT_GRID_DATA,
    SET_BARCODE_REPORT_GRID_FILTERS,
    SET_BARCODE_REPORT_MARKET_DROPDOWN,
    SET_BARCODE_REPORT_REGION_DROPDOWN,
    SET_BARCODE_REPORT_USER_DROPDOWN
} from './BarcodeReportType';

const initialState = {
    barcodeReportGridFilters: {},
    barcodeReportGridData: null,
    barcodeReportExcelData: null
}

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_BARCODE_REPORT_GRID_DATA:
            return {
                ...state,
                barcodeReportGridData: action.gridData,
            };
        case SET_BARCODE_REPORT_EXCEL_DATA:
            return {
                ...state,
                barcodeReportExcelData: action.excelData,
            };
        case SET_BARCODE_REPORT_USER_DROPDOWN:
            return {
                ...state,
                barcodeReportUserDropdown: action.userDropdown,
            };
        case SET_BARCODE_REPORT_REGION_DROPDOWN:
            return {
                ...state,
                barcodeReportRegionDropdown: action.regionDropdown,
            };
        case SET_BARCODE_REPORT_MARKET_DROPDOWN:
            return {
                ...state,
                barcodeReportMarketDropdown: action.marketDropdown,
            };
        case SET_BARCODE_REPORT_COSTCENTER_DROPDOWN:
            return {
                ...state,
                barcodeReportCostCenterDropdown: action.costCenterDropdown,
            };
        case SET_BARCODE_REPORT_GRID_FILTERS:
            return {
                ...state,
                barcodeReportGridFilters: { ...state.barcodeReportGridFilters, ...action.barcodeReportGridFilters },
            };
        case SET_BARCODE_REPORT_ASSET_IMAGES:
            return {
                ...state,
                barcodeReportAssetImages: action.assetImages,
            };
        default:
            return state;
    }
}

export default reducers;